import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedTeamsShowProjectsShowProjectVersionsShowBouncesListRoute extends BaseRoute {}
